enum TimelineTypes {
  Planning = "Planning",
  Production = "Production",
  Resource = "Resource",
}

export default TimelineTypes
